import SanityImage from './media/SanityImage.client';
import sanityConfig from '../../sanity.config';

import {useState} from 'react';

interface TesterCardsProps {
  component: any;
}

export function TesterCards({component}: TesterCardsProps) {
  const [activeCard, setActiveCard] = useState(component.testerCard[0]);

  return (
    <div className="full-width">
      <div className="m-5 lg:m-[40px]" id="st-testers">
        <div className="text-3xl border-b border-gray-500 mb-5 pb-5">
          Meet the Testers
        </div>
        <div className="flex flex-col lg:flex-row gap-y-6">
          <div className="lg:w-[300px] flex-grow-0 flex-shrink-0">
            {component.testerCard.map((card, index) => {
              return card.tester ? (
                <div
                  key={index}
                  className={`cursor-pointer mt-6 flex items-center gap-x-3 ${
                    card.tester.title == activeCard.tester?.title
                      ? 'font-bold'
                      : ''
                  }`}
                  aria-hidden="true"
                  onClick={() => {
                    setActiveCard(component.testerCard[index]);
                  }}
                >
                  <div className="flex-grow-0 w-[50px] h-[50px] rounded-full bg-gray-400">
                    {card.tester.mainImage && (
                      <SanityImage
                        alt={card.tester?.title}
                        dataset={sanityConfig.dataset}
                        layout="responsive"
                        objectFit="cover"
                        projectId={sanityConfig.projectId}
                        className="rounded-full"
                        src={card.tester.mainImage.asset._ref}
                      />
                    )}
                  </div>

                  {card.tester?.title}
                </div>
              ) : null;
            })}
          </div>
          <div className="flex-grow ">
            {activeCard && (
              <div className="shadow-[0_2px_7px_0_rgba(0,0,0,0.2)] rounded-xl overflow-hidden">
                {activeCard.tester && (
                  <div className="rounded-t-xl bg-[#232323] text-white flex items-center p-[20px]">
                    {activeCard.tester.mainImage && (
                      <div className=" w-[75px] h-[75px] md:w-[125px] md:h-[125px]">
                        <SanityImage
                          alt={''}
                          dataset={sanityConfig.dataset}
                          layout="responsive"
                          objectFit="cover"
                          projectId={sanityConfig.projectId}
                          className="rounded-full"
                          src={activeCard.tester.mainImage.asset._ref}
                        />
                      </div>
                    )}
                    <div className="flex-grow ml-4 md:ml-10">
                      <div className="mb-3">
                        <div className="text-[#5199fd] font-bold uppercase mb-1">
                          tester:
                        </div>
                        <div className="text-2xl lg:text-3xl pb-3 border-b border-white font-libre-baskerville">
                          {activeCard.tester.title}
                        </div>
                      </div>
                      <div className="inline-flex">
                        <span className="flex gap-1.5">
                          <span className="text-[#5199fd] font-bold uppercase">
                            Age:
                          </span>
                          <span className="">{activeCard.tester.age}</span>
                        </span>
                        <span className="flex gap-1.5 ml-4">
                          <span className="text-[#5199fd] font-bold uppercase">
                            Height:
                          </span>
                          <span className="">{activeCard.tester.height}</span>
                        </span>
                        {activeCard?.tester.ability_level && (
                          <span className="flex gap-1.5 ml-4">
                            <span className="text-[#5199fd] font-bold uppercase">
                              Ability Level:
                            </span>
                            <span className="">
                              {activeCard.tester.ability_level}
                            </span>
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                <div className="px-6 pt-6 block md:flex">
                  <div className="flex-grow">
                    <div className="font-bold uppercase mb-3 hidden md:block">
                      SKI:
                    </div>
                    <div className="flex-grow uppercase text-[#215AA8] font-extrabold text-xl lg:text-2xl">
                      {activeCard.product?.store?.title}
                    </div>
                  </div>

                  <div className="flex-grow text-left mt-5 md:mt-0 lg:text-right">
                    <div className="font-bold uppercase mb-3">Size Tested:</div>
                    <div className="flex-grow font-bold text-xl lg:text-2xl">
                      {activeCard.size_tested} CM
                    </div>
                  </div>
                </div>

                <div className="p-6 rounded-b-xl">
                  {activeCard.sizing_impressions && (
                    <div className="mb-8">
                      <div className="font-bold pb-1 border-b border-black uppercase mb-3">
                        Size Impression
                      </div>
                      <div className="font-klee-one text-lg">
                        {activeCard.sizing_impressions}
                      </div>
                    </div>
                  )}

                  <div className="mb-8">
                    <div className="font-bold pb-1 border-b border-black uppercase mb-3">
                      Scores
                    </div>
                    <div className="block sm:grid grid-cols-1 lg:grid-cols-2 gap-x-10 text-[#215AA8] font-bold uppercase text-xs max-w-7xl -mx-2">
                      <div className="p-2">
                        <div className="flex justify-between">
                          <span>Floatation:</span>
                          <span>{activeCard.floatation_score}/10</span>
                        </div>
                        <div className="mt-1 w-full h-[15px] rounded-2xl border border-[#215AA8]">
                          <div
                            className="bg-[#215AA8] h-[15px] rounded-2xl"
                            style={{
                              width: `${
                                (activeCard.floatation_score / 10) * 100
                              }%`,
                            }}
                          >
                            &nbsp;
                          </div>
                        </div>
                      </div>
                      <div className="p-2">
                        <div className="flex justify-between">
                          <span>Stability:</span>
                          <span>{activeCard.stability_score}/10</span>
                        </div>
                        <div className="mt-1 w-full h-[15px] rounded-2xl border border-[#215AA8]">
                          <div
                            className="bg-[#215AA8] h-[15px] rounded-2xl"
                            style={{
                              width: `${
                                (activeCard.stability_score / 10) * 100
                              }%`,
                            }}
                          >
                            &nbsp;
                          </div>
                        </div>
                      </div>
                      <div className="p-2 ">
                        <div className="flex justify-between">
                          <span>Quickness:</span>
                          <span>{activeCard.quickness_score}/10</span>
                        </div>
                        <div className="mt-1 w-full h-[15px] rounded-2xl border border-[#215AA8]">
                          <div
                            className="bg-[#215AA8] h-[15px] rounded-2xl"
                            style={{
                              width: `${
                                (activeCard.quickness_score / 10) * 100
                              }%`,
                            }}
                          >
                            &nbsp;
                          </div>
                        </div>
                      </div>
                      <div className="p-2 ">
                        <div className="flex justify-between">
                          <span>Playfulness:</span>
                          <span>{activeCard.playfulness_score}/10</span>
                        </div>
                        <div className="mt-1 w-full h-[15px] rounded-2xl border border-[#215AA8]">
                          <div
                            className="bg-[#215AA8] h-[15px] rounded-2xl"
                            style={{
                              width: `${
                                (activeCard.playfulness_score / 10) * 100
                              }%`,
                            }}
                          >
                            &nbsp;
                          </div>
                        </div>
                      </div>
                      <div className="p-2 ">
                        <div className="flex justify-between">
                          <span>Forgiveness:</span>
                          <span>{activeCard.forgiveness_score}/10</span>
                        </div>
                        <div className="mt-1 w-full h-[15px] rounded-2xl border border-[#215AA8]">
                          <div
                            className="bg-[#215AA8] h-[15px] rounded-2xl"
                            style={{
                              width: `${
                                (activeCard.forgiveness_score / 10) * 100
                              }%`,
                            }}
                          >
                            &nbsp;
                          </div>
                        </div>
                      </div>
                      <div className="p-2 ">
                        <div className="flex justify-between">
                          <span>Edge Grip:</span>
                          <span>{activeCard.edge_grip_score}/10</span>
                        </div>
                        <div className="mt-1 w-full h-[15px] rounded-2xl border border-[#215AA8]">
                          <div
                            className="bg-[#215AA8] h-[15px] rounded-2xl"
                            style={{
                              width: `${
                                (activeCard.edge_grip_score / 10) * 100
                              }%`,
                            }}
                          >
                            &nbsp;
                          </div>
                        </div>
                      </div>
                      <div className="p-2">
                        <div className="flex justify-between">
                          <span>Versatility:</span>
                          <span>{activeCard.versatility_score}/10</span>
                        </div>
                        <div className="mt-1 w-full h-[15px] rounded-2xl border border-[#215AA8]">
                          <div
                            className="bg-[#215AA8] h-[15px] rounded-2xl"
                            style={{
                              width: `${
                                (activeCard.versatility_score / 10) * 100
                              }%`,
                            }}
                          >
                            &nbsp;
                          </div>
                        </div>
                      </div>
                      <div className="p-2">
                        <div className="flex justify-between">
                          <span>Overall:</span>
                          <span>{activeCard.overall_score}/10</span>
                        </div>
                        <div className="mt-1 w-full h-[15px] rounded-2xl border border-[#215AA8]">
                          <div
                            className="bg-[#215AA8] h-[15px] rounded-2xl"
                            style={{
                              width: `${
                                (activeCard.overall_score / 10) * 100
                              }%`,
                            }}
                          >
                            &nbsp;
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="font-bold pb-1 border-b border-black uppercase mb-3">
                    Thoughts
                  </div>
                  <div className="space-y-4 mb-8">
                    {activeCard.terrain && (
                      <div className="mb-4">
                        <div className="font-klee-one text-lg">
                          {activeCard.terrain}
                        </div>
                      </div>
                    )}

                    {activeCard.other_feedback && (
                      <div className="mb-4">
                        <div className="font-klee-one text-lg">
                          {activeCard.other_feedback}
                        </div>
                      </div>
                    )}
                  </div>

                  {activeCard.overall_impression && (
                    <div className="mb-8">
                      <div className="font-bold pb-1 border-b border-black uppercase mb-3">
                        Overal Impression
                      </div>
                      <div className="font-klee-one text-lg">
                        {activeCard.overall_impression}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
